import * as React from "react";
import { observer } from "mobx-react";
import { TextField } from "@mui/material";
import { styled } from "@mui/material/styles";
import { FieldLabelWithHelp } from "./FieldHelpIcon";
import { useRootStore } from "../../../store/contexts";

type ShowStringProps = {
  label: string;
  value: string;
  helperText?: string;
  hidden?: boolean;
  description?: string;
};

// Campo de solo lectura: el borde se oculta con `transparent` y no
// pintandolo del color del fondo. Pintarlo de blanco funcionaba unicamente
// sobre fondo blanco; en modo oscuro dibujaba lineas blancas.
const CustomTextField = styled(TextField)`
   & label.Mui-focused {
     border-color: transparent
   },
   & .MuiInput-underline:after {
     border-color: transparent
   },
   & .MuiOutlinedInput-root {
     & fieldset {
       border-color: transparent
     },
     &:hover fieldset {
       border-color: transparent
     },
     &.Mui-focused fieldset {
       border-color: transparent
     },
   },
` as typeof TextField;

export const ShowString: React.FC<ShowStringProps> = observer(
  ({ label, value, helperText = "", hidden = false, description }) => {
    const { langStore } = useRootStore();
    if (hidden) return null;
    // Resolve any embedded multilang display fragment ({{"es":..,"en":..,"pt":..}},
    // produced by the generated <entity>DisplayId functions) to the active language.
    // No-op for plain strings, so this is safe for every string display.
    const displayValue = langStore.displayIdByLang(value ?? "");
    return (
      <CustomTextField
        size={"small"}
        inputProps={{ readOnly: true }}
        variant={"outlined"}
        helperText={helperText}
        sx={{ m: 1, mb: 1.5, width: 500 }}
        label={<FieldLabelWithHelp label={label} description={description} />}
        value={displayValue}
        InputLabelProps={description ? { shrink: true } : undefined}
      />
    );
  }
);
